const defineOpenSections = entry => {
  if (!entry) return [];
  const result = [];
  const getParent = item => {
    const itemParent = item === null || item === void 0 ? void 0 : item._parent;
    if (itemParent) {
      result.push(itemParent.id);
      itemParent._parent && getParent(itemParent);
    }
  };
  result.push(entry.id);
  getParent(entry);
  return result;
};

export { defineOpenSections };
